export abstract class INavigationService {
    // currentUrlAbstract: Observable<string>;
    abstract getMenuConfigurations(): any;
    abstract getParentPageId(): string;
    abstract setParentPageId(parentPageId: string);
    abstract getChildPageName(url: string): string;
    abstract setQueryParams(url: string);
    abstract getQueryParams(): any;
    abstract getGroupName(): string;
    abstract getDeviceType(): string;
    abstract setChildPageId(childId: string);
    abstract getChildPageId(): string;
    abstract handleNavigation(navigation: any);
    abstract handleNavigationWithDomain(domain: string);
    abstract setCurrentUrl(url: string);
    abstract getCurrentUrl(): any;
    abstract setParentPage(parentPage: any);
    abstract getParentPage(): any;
    abstract setChildPage(childpage: any);
    abstract getChildPage(): any;
    abstract setGrandChildPageId(grandChildId: string);
    abstract getGrandChildPageId(): string;
    abstract setGrandChildPage(grandChildPage: any);
    abstract getGrandChildPage(): any;
    abstract setFourthChildPageId(fourthChildId: string);
    abstract getFourthChildPageId(): string;
    abstract setFourthChildPage(fourthChildPage: any);
    abstract getFourthChildPage(): any;
    abstract setContextAndNavigate(domain: string, value: any, targetUrl: string, additionalNavInfo?: any);
    abstract navigateOnContext(contextType: string, contextValue: any): any;
    abstract navigateOnAction(contextType: string, contextValue: any, target: string): any;
    abstract getComingSoonMsgInd(): any;
    abstract setComingSoonMsgInd();
}
